import { SET_SOLICITATION_ID } from "./types";

export const setSolicitationId = data => ({
  type: SET_SOLICITATION_ID,
  data
});